// Footer.jsx
import { useEffect, useMemo, useState } from 'react';
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaLinkedin,
} from 'react-icons/fa';

export default function Footer() {
  // Menú sincronizado con Navbar (solo categorías principales)
  const menuData = useMemo(
    () => [
      { name: 'INICIO', path: 'inicio', url: '/' },
      {
        name: 'EMPAQUE Y LOGÍSTICA',
        path: 'empaque-logistica',
        url: '/category/empaque-y-logistica',
      },
      {
        name: 'SUMINISTROS INSTITUCIONALES',
        path: 'suministros',
        url: '/category/suministros-institucionales',
      },
      {
        name: 'GLOSARIO Y FORMACIÓN',
        path: 'glosario',
        url: '/category/glosario-y-formacion',
      },
      {
        name: 'TIENDA PACKSYS',
        path: 'tienda',
        url: 'https://packsys.com/',
      },
    ],
    []
  );

  const [activeCategory, setActiveCategory] = useState('inicio');

  // ESCUCHAR EVENTOS y cambios de ruta
  useEffect(() => {
    const handleArticleCategoryLoaded = (event) => {
      const categoryToUse = event.detail.mainCategory || event.detail.category;
      setActiveCategory(categoryToUse);
    };

    // Escuchar cambios en localStorage
    const checkLocalStorage = () => {
      try {
        const lastCategory = localStorage.getItem('lastActiveCategory');
        if (lastCategory) {
          const parsed = JSON.parse(lastCategory);
          const categoryToUse = parsed.mainCategory || parsed.category;
          setActiveCategory(categoryToUse);
        }
      } catch (error) {
        console.error('Error loading category in footer:', error);
      }
    };

    // Verificar cada segundo (fallback)
    const interval = setInterval(checkLocalStorage, 1000);

    window.addEventListener(
      'articleCategoryLoaded',
      handleArticleCategoryLoaded
    );

    // Verificar inmediatamente
    checkLocalStorage();

    return () => {
      window.removeEventListener(
        'articleCategoryLoaded',
        handleArticleCategoryLoaded
      );
      clearInterval(interval);
    };
  }, []);

  return (
    <footer className="bg-[#004c7f] text-white">
      <div className="container mx-auto px-6 py-6">
        <div className="flex flex-col items-center md:flex-row justify-center md:space-x-8 text-sm text-center space-y-3 md:space-y-0 font-semibold">
          {menuData.map((item) => (
            <a
              key={item.path}
              href={item.url}
              target={item.url.startsWith('http') ? '_blank' : '_self'}
              rel="noopener noreferrer"
              className={`transition-colors duration-200 ${
                activeCategory === item.path
                  ? 'text-[#47bb21] font-bold'
                  : 'hover:text-[#47bb21]'
              }`}
            >
              {item.name}
            </a>
          ))}
        </div>

        {/* Redes sociales */}
        <div className="flex justify-center space-x-6 mt-6 text-xl">
          <a
            href="https://www.facebook.com/packsys/"
            className="hover:text-[#47bb21]"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.instagram.com/infopacksys/?hl=es-la"
            className="hover:text-[#47bb21]"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.tiktok.com/@packsys"
            className="hover:text-[#47bb21]"
          >
            <FaTiktok />
          </a>
          <a
            href="https://www.youtube.com/user/infopacksys"
            className="hover:text-[#47bb21]"
          >
            <FaYoutube />
          </a>
          <a
            href="https://mx.linkedin.com/company/packsys"
            className="hover:text-[#47bb21]"
          >
            <FaLinkedin />
          </a>
        </div>

        {/* Copyright */}
        <div className="mt-6 text-center text-sm text-gray-200">
          Copyright © {new Date().getFullYear()}{' '}
          <a
            href="https://blog.packsys.com/"
            className="text-[#47bb21] font-semibold"
          >
            Packsys Academy.
          </a>{' '}
          Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
